import React from 'react';
import { Hline, scrollTo } from './App';
import { Bio } from './Frontpage';

const data = [
  {
    title: 'Expert Committee',
    data: [
      {
        pic: require('./assets/andy.png'),
        name: 'Tang, Andy',
        desp:
          "Andy has been engaged in research and development of communication equipment which are directly under the Central Government owned Enterprise of China, where his research achievements have won the third prize of National Scientific Progress. Also, he has led and managed China's largest industry and securities institute. Under his leadership and direct operation, it has completed about $3 billion of mergers and acquisitions investment to help listed companies for asset restructuring. Andy has extensive experience in IT and capital market operation."
      },
      {
        pic: require('./assets/david.png'),
        name: 'Lee, David',
        desp:
          'Professor Lee is teaching Quantitative Finance at Singapore University of Social Sciences, and he is founder of several companies including Left Coast, LiBai and Ferrell Group. He is also the founding investor in ZCash, Qtum and a few other blockchain companies and cryptocurrency. He is currently a professor in SIM University and is the 2015 Visiting Fulbright Scholar at Stanford University. He is an advisor to different blockchain organizations, and was the director of the Sim Kee Boon Institute for Financial Economics at Singapore Management University. He was the Group Managing Director of OUE and Auric Pacific. His operation and managing experience includes F&B, manufacturing, hospitality, hedge funds, stock brokerage, property management, property development, REITs, medical plastic components, listing and de-listing of companies, start-ups and multinationals.'
      },
      {
        pic: require('./assets/yiminyang.png'),
        name: 'Yang, Yimin',
        desp:
          "Yang Yimin, the Senior Director of Protiviti Inc., is mainly responsible for providing risk management consulting for large financial institutions.He has been doing financial risk management in PNC bank and SunTrust bank for many years. He has a Bachelor's degree from Peking University, master from Carnegie Mellon University, and PhD in Math from University of Chicago. He taught at University of Minnesota for years. Currently, he is also appointed as special researcher and Chief Overseas Consultant at China Financial Research Institute of Shanghai Jiaotong University, Shenzhen-Hong Kong Innovative Finance Research Institute, Qingdao Collaborative Innovation Center, as well as other provincial industrial technology research institutes."
      },
      {
        pic: require('./assets/biance.png'),
        name: 'Chen, Bianca',
        desp:
          "Bianca is a well-known bilingual host, financial columnist, and one of the pioneers of bitcoin in China. She previously published her first book <i>The Law of Maker</i> in 2015 and was named one of the 'Top 10 Most Influential Media Professionals' by WeMedia."
      },
      {
        pic: require('./assets/zhangming.png'),
        name: 'Zhang, Min',
        desp:
          'As founding partner at Empower Investment, Mr. Zhang is one of the top Angel Investors in China and also the founding partner at Empower Investment. He used to work at Morningside Venture Capital. Mr. Zhang focuses on middle and early stages equity investment in TMT area.'
      }
    ]
  },
  {
    title: 'Entrepreneur Partner',
    data: [
      {
        pic: require('./assets/james.png'),
        name: 'Gong, James',
        desp:
          'James is the founder of ChainB, which is one of the largest blockchain media in China. He has been promoting cryptocurrency and blockchain development since 2012, and has translated and written a large number of relevant documents. He is also the founder of ICOAge, Cybex as well as Longhash.'
      },
      {
        pic: require('./assets/yanfeng.png'),
        name: 'Chen, Yanfeng',
        desp:
          'Mr. Chen graduated from Shanghai Jiaotong University. He founded Tuolian, which provides blockchain asset trusteeship services. Mr. Chen is an early participant and investor in many blockchain projects, co-founded Cybex and Longhash, and he has a deep understanding of the industry in general.'
      },
      {
        pic: require('./assets/sunny.png'),
        name: 'Lu, Sunny',
        desp:
          "Mr. Lu is CEO of Vechain, as well as BITSE’s co-founder and COO, which has business development and partnerships with well-known enterprises like LV and PWC. He also served as Chief Information Officer for LV China and led the IS&T team to support business growth in more than 65 regions, including global/regional compliance deployment and planned rollout. He has business development experience with blockchain applications. He received bachelor's degree in Electronics and Communication Engineering from Shanghai Jiaotong University."
      },
      // {
      //   pic: require('./assets/eva.png'),
      //   name: 'Fu, Eva',
      //   desp:
      //     'As the founder of scry.info, she graduated from University of Electronic Science and Technology and Sorbonne University. She has master degrees in Computer Science and Applied Physics. She joined Red Union since high school and sell game products to Tencent during college. She has established a company focused on game and software, which has a project with hundreds of millions in terms of monthly revenue.'
      // },
      // {
      //   pic:require("./assets/jiangmengjun.png"),
      //   name:"Jiang, Mengjun",
      //   desp:"As the founder and CEO of Merculet, he has rich experience in enterprise SAAS solutions for foreign companies (HP, SAP, SuccessFactors) and marketing big data (AdMaster). He served as the core director of HP China, HP USA data management platform and new generation data center. He used to be a SAP chief engineer, the first representative of SAP cloud acceleration special action team in China as well as Vice President of AdMaster and general manager of Shanghai R&D center."
      // },
      {
        pic: require('./assets/qiaoke.png'),
        name: 'Qiao, Jack',
        desp:
          'Founder of Medishares and Zhongtopia, previous Senior Executive at China PingAn. He is a continual entrepreneur as well as Internet Society of China Director, China Youth Entrepreneurship and Employment Advisor.'
      },
      // {
      //   pic: require('./assets/charliexu.png'),
      //   name: 'Xu, Charlie',
      //   desp:
      //     'Founding partner of BKFund. Graduated from Anhui University, Charlie has served for high-tech companies such as iFLYTEK, Huawei and ZTE, etc. With 13 years of rich experience in R&D, marketing, management and entrepreneurial incubation practice, he was selected as "National Outstanding Innovation and Entrepreneurship Mentor" by the Ministry of Education. He is also the early participant and investor in the blockchain industry.'
      // },
      {
        pic: require('./assets/tan_terry.png'),
        name: 'Tan, Terry',
        desp:
          "Mr. Tan is the Founder and CEO of Public Chain BAIC and IMIO Labs. He is one of the young Internet entrepreneurs, Chairman of the IEEE Smart Home Security Standards Working Group, and Founder of “GFan“, which is the world's largest Android developer platform. He is the Founder of China's earliest PC hardware information website “Feixiangniao”. Also, he participated in founding of online game company Square Enix China."
      },
      {
        pic: require('./assets/ouyangmeng.png'),
        name: 'Ouyang, Meng',
        desp:
          'Mr. Ouyang graduated from the School of Software Engineering of Fudan University.  Being an expert in distributed storage and information security, he is the founder and CEO of Keystore (a top-tier crypto custody service provider) and KeyPool (a leading Filecoin mining solution provider).'
      }
    ]
  },
  {
    title: 'Investment Team',
    data: [
      {
        pic: require('./assets/huang_rin.png'),
        name: 'Huang, Rin',
        desp: 'Partner',
        ommision: false
      },
      {
        pic: require('./assets/duan_minfang.png'),
        name: 'Duan, Mingfang',
        desp: 'VP',
        ommision: false
      },
      // {
      //   pic: require('./assets/zhou_yuki.png'),
      //   name: 'Zhou, Yuki',
      //   desp: 'VP',
      //   ommision: false
      // },
      // {
      //   pic: require('./assets/shen_renqi.png'),
      //   name: 'Shen, Renqi',
      //   desp: 'Investment Director',
      //   ommision: false
      // },
      // {
      //   pic: require('./assets/yang_peter.png'),
      //   name: 'Yang, Peter',
      //   desp: 'Investment Director',
      //   ommision: false
      // },
      // {
      //   pic:require("./assets/jiang_xin.png"),
      //   name:"Jiang, Xin",
      //   desp:"Investment Manager",
      //   ommision:false
      // },
      // {
      //   pic: require('./assets/huang_chloe.png'),
      //   name: 'Huang, Chloe',
      //   desp: 'Investment Director',
      //   ommision: false
      // },
      // {
      //   pic: require('./assets/lu_stephanie.png'),
      //   name: 'Lu, Stephanie',
      //   desp: 'Investment Director',
      //   ommision: false
      // }
      // {
      //   pic:require("./assets/huang_steve.png"),
      //   name:"Huang, Steve",
      //   desp:'Investment Manager',
      //   ommision:false
      // },
    ]
  }
];

class Teams extends React.Component {
  componentDidMount() {
    scrollTo(0, 0);
  }
  render() {
    return (
      <div className="teams">
        <div className="wrap-height">
          <div className="cont">
            <Hline label="Our" title="Team" />{' '}
            {/* <h1>
                      {' '}
                      gf.network is founded by Shen Bo and other partners at Fenbushi Capital.It covers equity funds, global token funds, global
                      incubators as well as other institutions which are all dedicated to the healthy development of blockchain industry.{' '}
                    </h1> */}{' '}
            <h1>
              {' '}
              gf.network is founded by Shen Bo, other partners at Fenbushi Capital and veterans in the crypto - space.
              <br />
              It covers………{' '}
            </h1>{' '}
            {data.map(section => (
              <div key={section.title}>
                <div className="line-both-sides stitle">
                  <Hline label={section.title} nodot />
                </div>{' '}
                <div className="row mx-0 team-wrap">
                  {' '}
                  {section.data.map(({ pic, ...rest }, i) => (
                    <div className="col-md-4" key={i}>
                      <Bio
                        center
                        avator={() => (
                          <div className="avator">
                            {' '}
                            <img src={pic} alt="" />{' '}
                          </div>
                        )}
                        {...rest}
                      />{' '}
                    </div>
                  ))}{' '}
                </div>{' '}
              </div>
            ))}{' '}
          </div>{' '}
        </div>{' '}
      </div>
    );
  }
}

export default Teams;

// WEBPACK FOOTER //
// ./src/Teams.js
